<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.height < 786
          ? { 'min-height': '100vh', 'background-color': '#E9E9E9' }
          : { height: 'auto', 'background-color': '#E9E9E9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="8" align="center">
                <v-text-field
                  class="centered-input-header"
                  :value="
                    SiteName == '' || ParkingInfoPageActiveStatus == false
                      ? ''
                      : SiteName
                  "
                  disabled
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <p
                  style="
                    text-align: center;
                    font-size: 22px;
                    color: #14223c;
                    cursor: pointer;
                  "
                  @click="OpenCheckPermissionDialog()"
                >
                  <span style="width: 100px">
                    <v-icon size="28" @click="BackToMain()"
                      >mdi-arrow-left-circle-outline</v-icon
                    >
                  </span>
                  {{ $t("message.ParkingInformation") }}
                </p>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="7" align="center" class="white rounded-sm">
                <table style="border-collapse: collapse; width: 100%">
                  <tr>
                    <td style="color: #14223c">{{ $t("message.TicketNo") }}</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TicketNo }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">{{ $t("message.DateTime") }}</td>
                    <td style="text-align: right; color: #14223c">
                      {{ DateTime }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">{{ $t("message.TimeIn") }}</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TimeIn }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">{{ $t("message.Duration") }}</td>
                    <td style="text-align: right">{{ Duration }}</td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">
                      {{ $t("message.CarLicense") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ CarLicense }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">
                      {{ $t("message.VehicleName") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ VehicleName }}
                    </td>
                  </tr>

                  <tr>
                    <td style="color: #14223c">
                      {{ $t("message.NormalServiceRate") }}
                    </td>
                    <td style="text-align: right; color: #14223c; cursor: pointer;" @click="OpenHistoryRedemptionDialog()">
                      <div>
                        {{
                          $t("message.RateDetailLang") == "ENG"
                            ? RateDetailENG.split("\r\n")[0]
                            : RateDetail.split("\r\n")[0]
                        }}
                      </div>
                      <div>
                        {{
                          $t("message.RateDetailLang") == "ENG"
                            ? RateDetailENG.split("\r\n")[1]
                            : RateDetail.split("\r\n")[1]
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-show="
                      (UsagePOSValue != 0 && UsagePOSValue != null) ||
                      (UsageCouponValue != 0 && UsageCouponValue != null)
                    "
                  >
                    <td style="color: #14223c; text-decoration: underline">
                      {{ $t("message.PromotionDiscount") }}
                    </td>
                  </tr>

                  <tr v-show="UsagePOSValue != 0 && UsagePOSValue != null">
                    <td style="color: #14223c; text-indent: 2em">
                      {{ $t("message.ReceiptFromPurchase") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ UsagePOSValue }} {{ $t("message.Hour") }}
                    </td>
                  </tr>

                  <tr
                    v-show="UsageCouponValue != 0 && UsageCouponValue != null"
                  >
                    <td style="color: #14223c; text-indent: 2em">
                      {{ $t("message.UsageCoupon") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ UsageCouponValue }} {{ $t("message.Hour") }}
                    </td>
                  </tr>
                  <tr
                    v-show="
                      (UsagePOSValue != 0 && UsagePOSValue != null) ||
                      (UsageCouponValue != 0 && UsageCouponValue != null)
                    "
                  >
                    <td style="color: #14223c; text-indent: 2em">
                      {{ $t("message.TotalPromotionDiscount") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ UsagePOSValue + UsageCouponValue }}
                      {{ $t("message.Hour") }}
                    </td>
                  </tr>

                  <tr>
                    <td style="color: #14223c">{{ $t("message.Total") }}</td>
                    <td style="text-align: right; color: green">
                      <span style="font-size: 16px">{{
                        numberWithCommas(Total)
                      }}</span>
                      <span style="color: black">
                        {{ $t("message.Baht") }}</span
                      >
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4">
                <div
                  v-if="
                    (RedemptionType == 0 || RedemptionType == 2) &&
                    RateData == null
                  "
                >
                  <p style="font-size: 16px">
                    {{ $t("message.SpendingValue") }}
                  </p>
                  <v-text-field v-model="SpendingValue" solo />
                </div>
                <div
                  v-if="
                    (RedemptionType == 1 || RedemptionType == 2) &&
                    POSValue == '' &&
                    SpendingValue == '' &&
                    CouponValue == '' &&
                    RateList.length > 0
                  "
                  class="mt-5"
                  @click="ClearRate()"
                >
                  <p style="font-size: 16px">{{ $t("message.RateDetail") }}</p>
                  <v-radio-group
                    v-model="RateData"
                    style="margin-left: auto; margin-right: auto"
                  >
                    <v-radio
                      style="
                        border-style: solid;
                        border-color: white;
                        background-color: white;
                        height: 50px;
                        padding-left: 1rem;
                        padding-right: 1rem;
                      "
                      v-for="(item, index) in RateList"
                      :key="index"
                      :label="
                        $t('message.RateDetailLang') == 'ENG'
                          ? item.rateDetailEng
                          : item.rateDetail
                      "
                      :value="item.rateCode"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="6">
                <p style="font-size: 16px">{{ $t("message.Remark") }}</p>
                <v-textarea v-model="Remark" solo></v-textarea>
              </v-col>
            </v-row>
            <v-row
              cols="12"
              xs="12"
              sm="12"
              md="12"
              justify="center"
              style="margin-top: -1%"
            >
              <v-col cols="12" md="4" align="center">
                <v-btn
                  v-if="RedeemButtonStatus == false"
                  height="40"
                  width="150"
                  outlined
                  color="indigo"
                  @click="RedeemData()"
                >
                  {{ $t("message.EStamp") }}
                </v-btn>
                <v-btn
                  v-else
                  disabled
                  height="40"
                  width="150"
                  outlined
                  color="indigo"
                  @click="RedeemData()"
                >
                  {{ $t("message.EStamp") }}
                </v-btn>
                &nbsp;
                <v-btn
                  height="40"
                  width="150"
                  outlined
                  color="red"
                  @click="CancelRedeem()"
                >
                  {{ $t("message.Cancel") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12"></v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>
    <br />
    <v-footer
      :color="
        ThemeColor == '' || ParkingInfoPageActiveStatus == false
          ? '#1d2939'
          : ThemeColor
      "
      :absolute="$vuetify.breakpoint.height < 786 ? false : true"
      class="white--text text-caption footer"
    >
    <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row no-gutters>
            <v-col cols="12" xs="12" sm="4" md="4" lg="2"></v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="1">
              <v-img
                src="@/assets/logo_fs.svg"
                width="80"
                class="mx-auto mt-1"
              ></v-img>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="3">
              <div class="mt-2">
                <span style="font-size: small; margin-bottom: 5px; color: white"
                  >Copyright © 2023 Forward System Co. Ltd. All rights reserved.</span
                >
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="6"></v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" sm="2" md="2"> </v-col>
      </v-row>
    </v-footer>

    <v-dialog v-model="HistoryRedemptionDialog" persistent width="700">
      <v-card>
        <v-card-title>
          <p>Redemption History</p>
          <v-spacer></v-spacer>
          <v-btn @click="CloseHistoryRedemptionDialog()" icon>
            <img src="@/assets/close.png" width="15" height="15" />
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-data-table
              :headers="headersRedempList"
              :items="HistoryRedempList"
              hide-default-footer
              style="color: #332f2fde"
              single-line
              hide-details
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="header-table-css">
                    {{ ChangeFormatDate(item.datetime) }}
                  </td>
                  <td class="header-table-css">
                    {{ item.rateCode }}
                  </td>
                  <td class="header-table-css">
                    {{ item.rateDetail }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ScannerDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>{{ $t("message.Scanner") }}</p>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="6">
              <StreamBarcodeReader
                ref="scannerQR"
                @decode="onDecode"
              ></StreamBarcodeReader>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <v-row v-if="TempCPNo != '' && TempCPAmount != ''">
            <v-col cols="12" md="3"></v-col>
            <v-col
              cols="12"
              md="3"
              align="center"
              v-show="TempCPNo != ''"
              style="font-size: 15px; color: black"
            >
              CPNo: <span style="color: green">{{ TempCPNo }}</span>
            </v-col>
            <v-col
              cols="12"
              md="3"
              align="center"
              v-show="TempCPAmount != ''"
              style="font-size: 15px; color: black"
            >
              Amount: <span style="color: green">{{ TempCPAmount }}</span>
              {{ $t("message.Hour") }}
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" md="3"></v-col>
            <v-col
              style="font-size: 15px; color: black"
              cols="12"
              md="3"
              align="center"
              v-show="TempSNScanDetail != ''"
            >
              SN: <span style="color: green">{{ TempSNScanDetail }}</span>
            </v-col>
            <v-col
              style="font-size: 15px; color: black"
              cols="12"
              md="3"
              align="center"
              v-show="TempAmountScanDetail != ''"
            >
              Amount:
              <span style="color: green">{{ TempAmountScanDetail }}</span>
              {{ $t("message.Baht") }}
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <v-row v-show="ResponseQRTigerText != ''">
            <v-col cols="12" md="3"></v-col>
            <v-col
              style="font-size: 15px; color: red"
              cols="12"
              md="6"
              align="center"
            >
              {{ ResponseQRTigerText }}
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <v-row v-if="TempCPNo != '' && TempCPAmount != ''">
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="4" align="center">
              <v-text-field
                disabled
                :placeholder="$t('message.CouponValue')"
                v-model="TempCouponValue"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4"></v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="4" align="center">
              <v-text-field
                :placeholder="$t('message.POSValueOrCoupon')"
                v-model="TempPOSValue"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4"></v-col>
          </v-row>
          <v-row
            style="margin-top: -2rem"
            v-if="TempCPNo != '' && TempCPAmount != ''"
          >
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="4" align="center">
              <v-btn
                height="40"
                width="100"
                color="primary"
                class="white--text ml-0"
                @click="AddTempDataCoupon()"
              >
                {{ $t("message.Add") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="4"></v-col>
          </v-row>
          <v-row style="margin-top: -2rem" v-else>
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="4" align="center">
              <v-btn
                v-if="AddPOSButtonStatus == false"
                height="40"
                width="90"
                color="primary"
                class="white--text"
                @click="AddTempDataPOS()"
              >
                {{ $t("message.Add") }}
              </v-btn>
              <v-btn
                v-else
                disabled
                height="40"
                width="90"
                color="primary"
                class="white--text"
                @click="AddTempDataPOS()"
              >
                {{ $t("message.Add") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="4"></v-col>
          </v-row>
          <v-row>
            <v-col align="center">
              <div>
                <v-data-table
                  :headers="$i18n.locale == 'th' ? headersTH : headers"
                  :items="ScannerList"
                  style="color: #444444"
                  :items-per-page="5"
                  single-line
                  hide-details
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.trn_Log_Carpark_ID }}</td>
                      <td>{{ item.sale_Number }}</td>
                      <td>{{ item.branch == "" ? "-" : item.branch }}</td>
                      <td>{{ item.amount }}</td>
                      <td>{{ ConvertDate(item.stampDate) }}</td>
                      <td>{{ item.type == 1 ? "POS" : "Coupon" }}</td>
                      <td>
                        {{
                          item.statusApprove == 1 ? "Approve" : "Not Approve"
                        }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="3">
              <span style="font-size: 18px; color: black"
                >{{ $t("message.TotalAmount") }}:
                <span style="color: green">{{
                  numberWithCommas(TotalAmountPOS)
                }}</span>
                {{ $t("message.Baht") }}</span
              >
            </v-col>
            <v-col cols="12" md="4">
              <span style="font-size: 18px; color: black"
                >{{ $t("message.TotalCoupon") }}:
                <span style="color: green">{{ TotalCouponAmount }}</span>
                {{ $t("message.Hour") }}</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10" align="center">
              <v-btn
                height="40"
                width="150"
                color="success"
                @click="SubmitPOSValue()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
              <v-btn
                height="40"
                width="150"
                color="red"
                class="white--text"
                @click="CloseScannerDialog()"
              >
                {{ $t("message.Cancel") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckPermissionDialog" persistent width="300">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseCheckPermissionDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row style="margin-bottom: -50px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-text-field
                placeholder="Username"
                type="text"
                outlined
                v-model="UserAdmin"
                @keyup.enter="LoginPermission"
              />
              <v-text-field
                placeholder="Password"
                type="password"
                outlined
                v-model="PasswordAdmin"
                @keyup.enter="LoginPermission"
              />
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
          <v-row style="margin-bottom: -40px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-btn
                block
                color="#1D2939"
                style="color: white"
                @click="LoginPermission()"
                class="rounded-lg"
                x-large
                >Login</v-btn
              >
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SettingParkingInfoDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>Setting</p>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseSettingParkingInfoDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="ml-5 mr-2">
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">SiteName</p>
              <div>
                <v-text-field v-model="SiteName" solo></v-text-field>
              </div>
            </v-col>
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">Theme Color</p>
              <div>
                <v-color-picker
                  v-model="ThemeColor"
                  dot-size="20"
                  class="ma-2"
                  mode="hexa"
                ></v-color-picker>
              </div>
            </v-col>
          </v-row>
          <v-row class="ml-5 mr-2">
            <p style="text-align: left; font-size: 16px; color: black">
              Status
            </p>
            <v-radio-group inline v-model="ParkingInfoPageActiveStatus">
              <v-radio label="Active" value="1"></v-radio>
              <v-radio label="InActive" value="2"></v-radio>
            </v-radio-group>
          </v-row>
          <hr class="mt-2" />
          <v-row>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10" align="right">
              <v-btn
                height="40"
                width="150"
                color="success"
                outlined
                @click="SaveSettingParkingInfo()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
              <v-btn
                height="40"
                width="150"
                color="red"
                outlined
                @click="CloseSettingParkingInfoDialog()"
              >
                {{ $t("message.Cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <AlertComponent
      :flagAlert="AlertDialog"
      :typeAlert="TypeAlert"
      :mesAlert="MessageAlert"
      @flagClose="ClearDataAlert()"
    />
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import AlertComponent from "@/components/Alert";
import LoadingComponent from "@/components/Loading";
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
  name: "ParkingInformation",
  components: {
    AlertComponent,
    LoadingComponent,
    StreamBarcodeReader,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      id: null,
      response: "",
      RedemptionType: null,
      TenantID: null,
      LogID: null,
      TerminalID: null,
      DatetimeIn: "",
      MemberType: null,
      CarType: null,
      UserID: null,

      TicketNo: "",
      DateTime: "",
      TimeIn: "",
      Duration: "",
      CarLicense: "",
      VehicleName: "",
      RateCodeString: "",
      RateDetail: "",
      RateDetailENG: "",
      Total: "",
      SpendingValue: "",
      RateList: [],
      RateData: null,
      OldRateData: null,
      Remark: "",

      QRCodeData: "",
      idqr: null,
      POSValue: "",
      TempPOSValue: "",
      ScannerDialog: false,
      ScannerList: [],
      TempScannerList: [],
      TotalAmountPOS: 0,
      UsagePOSValue: 0,

      TempSNScanDetail: "",
      TempAmountScanDetail: "",

      StatusReader: false,
      AddPOSButtonStatus: false,
      RedeemButtonStatus: false,
      DepartmentID: localStorage.getItem("departmentId"),
      HistoryRedemptionDialog: false,
      HistoryRedempList: [],

      CouponValue: "",
      TempCPNo: "",
      TempCPAmount: "",
      TempCouponValue: "",
      TotalCouponAmount: null,
      UsageCouponValue: 0,
      ResponseQRTigerText: "",
      ResponseData: [],

      CheckPermissionDialog: false,
      SiteName: "",
      ThemeColor: "",
      ParkingInfoPageActiveStatus: false,
      UserAdmin: "",
      PasswordAdmin: "",
      SettingParkingInfoDialog: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "CarparkID",
          sortable: false,
          align: "left",
        },
        {
          text: "SerialNumber",
          sortable: false,
          align: "left",
        },
        {
          text: "Branch",
          align: "left",
          sortable: false,
        },
        {
          text: "Amount",
          align: "left",
          sortable: false,
        },
        {
          text: "StampDate",
          align: "left",
          sortable: false,
        },
        {
          text: "Type",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          align: "left",
          sortable: false,
        },
      ];
    },
    headersTH() {
      return [
        {
          text: "เลขบัตรจอดรถ",
          sortable: false,
          align: "left",
        },
        {
          text: "หมายเลขซีเรียล",
          sortable: false,
          align: "left",
        },
        {
          text: "สาขา",
          align: "left",
          sortable: false,
        },
        {
          text: "จำนวนเงิน",
          align: "left",
          sortable: false,
        },
        {
          text: "วันที่ประทับ",
          align: "left",
          sortable: false,
        },
        {
          text: "ประเภท",
          align: "left",
          sortable: false,
        },
        {
          text: "สถานะ",
          align: "left",
          sortable: false,
        },
      ];
    },
    headersRedempList() {
      return [
        {
          text: "TimeStamp",
          align: "left",
          sortable: false,
        },
        {
          text: "RateCode",
          align: "left",
          sortable: false,
        },
        {
          text: "RateDetail",
          align: "left",
          sortable: false,
        },
      ];
    },
  },
  watch: {},

  methods: {
    GetRedemptionHistory(logID) {
      let self = this;
      let temp = {
        LogCarparkID: logID,
      };
      axios
        .post(`${self.url}Redemption/GetRedemptionHistory`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.HistoryRedempList = response.data.data == null ? [] : response.data.data;         
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    OpenHistoryRedemptionDialog(){
      let self = this;
      self.HistoryRedemptionDialog = true;
    },

    CloseHistoryRedemptionDialog(){
      let self = this;
      self.HistoryRedemptionDialog = false;
    },

    ClearRate() {
      let that = this;
      if (that.OldRateData == that.RateData) {
        that.RateData = null;
      }
      that.OldRateData = that.RateData;
    },

    SaveSettingParkingInfo() {
      let self = this;
      let temp = {
        SiteName: self.SiteName,
        ThemeColor: self.ThemeColor,
        ActiveStatus: self.ParkingInfoPageActiveStatus,
      };
      axios
        .post(`${self.url}Setting/SaveSettingParkingInfoPage`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SettingParkingInfoDialog = false;
            self.CheckPermissionDialog = false;
            self.UserAdmin = "";
            self.PasswordAdmin = "";
            self.LoadDataSettingParkingInfo();
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          alert(error);
        });
    },

    LoginPermission() {
      let self = this;
      if (
        self.UserAdmin.toLocaleLowerCase() == "admin" &&
        self.PasswordAdmin.toLocaleLowerCase() == "fscp_1"
      ) {
        self.OpenSettingParkingInfoPage();
      } else {
        self.MessageAlert = "รหัสผ่านไม่ถูกต้อง !";
        self.TypeAlert = "error";
        self.AlertDialog = true;
      }
    },

    OpenSettingParkingInfoPage() {
      let self = this;
      self.SettingParkingInfoDialog = true;
    },

    CloseSettingParkingInfoDialog() {
      let self = this;
      self.UserAdmin = "";
      self.PasswordAdmin = "";
      self.CheckPermissionDialog = false;
      self.SettingParkingInfoDialog = false;
    },

    CloseCheckPermissionDialog() {
      let self = this;
      self.UserAdmin = "";
      self.PasswordAdmin = "";
      self.CheckPermissionDialog = false;
      self.SettingParkingInfoDialog = false;
    },

    BackToMain() {
      let self = this;
      self.$router.push({ name: "Main" });
    },

    onDecode(temp) {
      let self = this;
      self.QRCodeData = temp;
      self.StatusReader = true;
      self.SearchPOSQRCode();
    },

    SearchPOSQRCode() {
      let self = this;
      self.TempSNScanDetail = "";
      self.TempAmountScanDetail = "";
      self.ResponseQRTigerText = "";
      self.TempCPNo = "";

      if (self.QRCodeData == "") {
        self.ResponseQRTigerText = "กรุณาสแกนใหม่อีกครั้ง !";
        alert("กรุณาสแกนใหม่อีกครั้ง !");
      } else {
        if (self.QRCodeData.substring(0, 3) == "PMS") {
          let tempdata = {
            QRData: self.QRCodeData,
            Coupon_Type: parseInt(self.CarType) == 0 ? 1 : 2, // 1 = Car 2 = Motorcycle
          };
          axios
            .post(`${self.url}Redemption/GetCouponByQRCode`, tempdata)
            .then(function (response) {
              if (response.data.status == 0) {
                if (
                  self.ScannerList.filter(
                    (x) => x.sale_Number == response.data.data.cP_No
                  ).length > 0
                ) {
                  if (self.$i18n.locale == "en") {
                    //คูปองนี้ถูกใช้ไปแล้ว
                    self.ResponseQRTigerText =
                      "Sorry, Coupon has been redeemed already. Please check again.";
                    alert(
                      "Sorry, Coupon has been redeemed already. Please check again."
                    );
                    self.GetDataPOSCoupon();
                  } else {
                    self.ResponseQRTigerText =
                      "ขออภัย คูปองนี้ถูกใช้ไปแล้ว กรุณาตรวจสอบอีกครั้ง";
                    alert("ขออภัย คูปองนี้ถูกใช้ไปแล้ว กรุณาตรวจสอบอีกครั้ง");
                    self.GetDataPOSCoupon();
                  }
                } else {
                  self.TempCPNo = response.data.data.cP_No;
                  self.TempCPAmount = response.data.data.discount_Value;
                  self.TempCouponValue = response.data.data.discount_Value;
                  let temp = {
                    SerialNumber: response.data.data.cP_No,
                    Branch: "",
                    Datetime: "",
                    Amount: parseInt(response.data.data.discount_Value),
                    LogCarparkID: self.LogID,
                    EntryDate: "",
                    UserID: localStorage.getItem("UserID"),
                  };
                  self.TempScannerList.push(temp);
                }
              } else {
                self.TempSNScanDetail = "";
                self.TempAmountScanDetail = "";
                if (response.data.message == "ประเภทของคูปองไม่ถูกต้อง") {
                  //ประเภทของคูปองไม่ถูกต้อง
                  if (self.$i18n.locale == "th") {
                    self.ResponseQRTigerText =
                      "Sorry, Wrong type of coupon. Please check and try again.";
                    alert(
                      "Sorry, Wrong type of coupon. Please check and try again."
                    );
                  } else {
                    self.ResponseQRTigerText =
                      "ขออภัย ประเภทคูปองไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง";
                    alert(
                      "ขออภัย ประเภทคูปองไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง"
                    );
                  }
                } else if (response.data.message == "คูปองหมดอายุแล้ว") {
                  //คูปองหมดอายุแล้ว
                  if (self.$i18n.locale == "th") {
                    self.ResponseQRTigerText =
                      "Sorry, Coupon has expired. Please check and try again.";
                    alert(
                      "Sorry, Coupon has expired. Please check and try again."
                    );
                  } else {
                    self.ResponseQRTigerText =
                      "ขออภัย คูปองหมดอายุ กรุณาตรวจสอบและลองอีกครั้ง";
                    alert("ขออภัย คูปองหมดอายุ กรุณาตรวจสอบและลองอีกครั้ง");
                  }
                } else if (
                  response.data.message == "กรุณาตรวจสอบ QRCode ใหม่อีกครั้ง !"
                ) {
                  //กรุณาตรวจสอบ QRCode ใหม่อีกครั้ง !
                  if (self.$i18n.locale == "th") {
                    self.ResponseQRTigerText =
                      "Sorry, Wrong QR Code type. Please check and try again.";
                    alert(
                      "Sorry, Wrong QR Code type. Please check and try again."
                    );
                  } else {
                    self.ResponseQRTigerText =
                      "ขออภัย QR Code ไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง";
                    alert(
                      "ขออภัย QR Code ไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง"
                    );
                  }
                } else if (response.data.message == "QR Wrong !") {
                  //QR Wrong !
                  if (self.$i18n.locale == "th") {
                    self.ResponseQRTigerText =
                      "Sorry, Wrong QR Code type. Please check and try again.";
                    alert(
                      "Sorry, Wrong QR Code type. Please check and try again."
                    );
                  } else {
                    self.ResponseQRTigerText =
                      "ขออภัย QR Code ไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง";
                    alert(
                      "ขออภัย QR Code ไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง"
                    );
                  }
                } else {
                  self.ResponseQRTigerText = response.data.message;
                  alert(response.data.message);
                }
              }
            })
            .catch(function () {
              if (self.$i18n.locale == "th") {
                self.ResponseQRTigerText =
                  "Sorry, Wrong QR Code type. Please check and try again.";
                alert("Sorry, Wrong QR Code type. Please check and try again.");
              } else {
                self.ResponseQRTigerText =
                  "ขออภัย QR Code ไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง";
                alert("ขออภัย QR Code ไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง");
              }
              // self.ResponseQRTigerText = "กรุณาตรวจสอบ QR ใหม่อีกครั้ง!";
              // alert("กรุณาตรวจสอบ QR ใหม่อีกครั้ง!");
            });
        } else {
          let temp = {
            QRData: self.QRCodeData,
            LogCarparkID: self.LogID,
            EntryDate: self.DatetimeIn,
            UserID: localStorage.getItem("UserID"),
          };
          axios
            .post(`${self.url}Redemption/GetTigerReceiptByQRCode`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                self.TempCPNo == "";
                self.TempCPAmount = "";
                self.TempPOSValue =
                  response.data.data.amt == ""
                    ? ""
                    : parseFloat(response.data.data.amt);
                self.TempSNScanDetail = response.data.data.sn;
                self.TempAmountScanDetail = response.data.data.amt;
                let temp = {
                  SerialNumber: response.data.data.sn,
                  Branch: response.data.data.bc,
                  Datetime: response.data.data.dtr,
                  Amount: response.data.data.amt,
                  LogCarparkID: self.LogID,
                  EntryDate: self.DatetimeIn,
                  UserID: localStorage.getItem("UserID"),
                };
                self.TempScannerList.push(temp);
              } else {
                self.TempSNScanDetail = "";
                self.TempAmountScanDetail = "";
                self.ResponseQRTigerText = response.data.message;
                alert(response.data.message);
              }
            })
            .catch(function () {
              self.ResponseQRTigerText = "กรุณาตรวจสอบ QR ใหม่อีกครั้ง!";
              alert("กรุณาตรวจสอบ QR ใหม่อีกครั้ง!");
            });
        }
      }
    },

    ConvertDate(value) {
      var response = new Date(value).toLocaleString();
      return response;
    },

    CloseReader() {
      let self = this;
      self.$refs.scannerQR.codeReader.stream
        .getTracks()
        .forEach(function (track) {
          track.stop();
        });
    },

    SubmitPOSValue() {
      let self = this;
      self.POSValue = self.TotalAmountPOS == 0 ? null : self.TotalAmountPOS;
      self.CouponValue =
        self.TotalCouponAmount == 0 ? null : self.TotalCouponAmount;
      self.UsageCouponValue =
        self.TotalCouponAmount == 0 ? null : self.TotalCouponAmount;
      self.ScannerDialog = false;
      if (self.TotalAmountPOS != 0) {
        let temp = {
          LogCarparkID: self.LogID,
        };
        axios
          .post(`${self.url}Redemption/GetPromotionTiger`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.UsagePOSValue = response.data.data.freeHour;
            }
          })
          .catch(function (error) {
            self.MessageAlert = error;
            self.TypeAlert = "error";
            self.AlertDialog = true;
          });
      }
    },

    AddTempDataCoupon() {
      let self = this;
      let temp = {};
      for (let i = 0; i < self.TempScannerList.length; i++) {
        temp = {
          Amount: self.TempScannerList[i].Amount,
          Branch: self.TempScannerList[i].Branch,
          Datetime: self.TempScannerList[i].Datetime,
          EntryDate: self.TempScannerList[i].EntryDate,
          LogCarparkID: self.TempScannerList[i].LogCarparkID,
          SerialNumber: self.TempScannerList[i].SerialNumber,
          UserID: self.TempScannerList[i].UserID,
        };
      }
      axios
        .post(`${self.url}Redemption/AddCouponForRedeem`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TempCPNo = "";
            self.TempCPAmount = "";
            self.TempCouponValue = "";
            self.TempSNScanDetail = "";
            self.TempAmountScanDetail = "";
            self.TempPOSValue = "";
            self.GetDataPOSCoupon();
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    AddTempDataPOS() {
      let self = this;
      if (parseInt(self.TempPOSValue) > parseInt(self.TempAmountScanDetail)) {
        alert("ยอดที่ใช้มีมูลค่าเกินยอดของใบเสร็จ !");
      } else {
        self.AddPOSButtonStatus = true;
        let temp = {};
        for (let i = 0; i < self.TempScannerList.length; i++) {
          temp = {
            Amount: parseInt(self.TempPOSValue),
            Branch: self.TempScannerList[i].Branch,
            Datetime: self.TempScannerList[i].Datetime,
            EntryDate: self.TempScannerList[i].EntryDate,
            LogCarparkID: self.TempScannerList[i].LogCarparkID,
            SerialNumber: self.TempScannerList[i].SerialNumber,
            UserID: self.TempScannerList[i].UserID,
          };
        }
        axios
          .post(`${self.url}Redemption/AddTigerReceiptForRedeem`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.TempCPNo = "";
              (self.TempCPAmount = ""), (self.TempCouponValue = "");
              self.TempSNScanDetail = "";
              self.TempAmountScanDetail = "";
              self.TempPOSValue = "";
              self.GetDataPOS();
              self.AddPOSButtonStatus = false;
            }
            self.AddPOSButtonStatus = false;
          })
          .catch(function (error) {
            self.MessageAlert = error;
            self.TypeAlert = "error";
            self.AlertDialog = true;
            // alert(error);
            self.AddPOSButtonStatus = false;
          });
      }
    },

    GetDataPOSCoupon() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      axios
        .post(`${self.url}Redemption/GetTigerReceiptRedeemUsed`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ScannerList = response.data.data;
            self.TotalCouponAmount = 0;
            for (let i = 0; i < self.ScannerList.length; i++) {
              if (
                self.ScannerList[i].type == 2 &&
                self.ScannerList[i].statusApprove == "0"
              ) {
                self.TotalCouponAmount += self.ScannerList[i].amount;
              }
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    GetDataPOS() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      axios
        .post(`${self.url}Redemption/GetTigerReceiptRedeemUsed`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ScannerList = response.data.data;
            self.TotalAmountPOS = 0;
            for (let i = 0; i < self.ScannerList.length; i++) {
              if (
                self.ScannerList[i].type == 1 &&
                self.ScannerList[i].statusApprove == "0"
              ) {
                self.TotalAmountPOS += self.ScannerList[i].amount;
              }
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    OpenScannerDialog() {
      let self = this;
      self.GetDataPOS();
      self.GetDataPOSCoupon();
      self.ScannerDialog = true;
    },

    CloseScannerDialog() {
      let self = this;
      self.DeletePreviousPOS();
      self.ScannerDialog = false;
      self.QRCodeData = "";
      self.TempSNScanDetail = "";
      self.TempAmountScanDetail = "";
      self.TempPOSValue = "";
      self.POSValue = "";
      self.CouponValue = "";
      self.UsageCouponValue = 0;
      self.UsagePOSValue = 0;
      self.ResponseQRTigerText = "";
    },

    DeletePreviousPOS() {
      let self = this;
      self.CancelTigerReceiptRedeem();
      self.CancelCouponRedeem();
      // self.ReloadDataParkingInformationDetail();
    },

    async CancelTigerReceiptRedeem() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      await axios
        .post(`${self.url}Redemption/CancelTigerReceiptRedeem`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // alert(error);
          // self.LoadingDialog = false;
        });
    },

    async CancelCouponRedeem() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      await axios
        .post(`${self.url}Redemption/CancelCouponRedeem`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // alert(error);
          // self.LoadingDialog = false;
        });
    },

    async ReloadDataParkingInformationDetail() {
      let self = this;
      // self.LoadingDialog = true;
      let temp = {
        search: self.LogID,
      };
      await axios
        .post(`${self.url}Redemption/GetParkingDetail`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
          }
          // self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // alert(error);
          // self.LoadingDialog = false;
        });
    },

    ClearDataAlert() {
      let self = this;
      self.AlertDialog = false;
      self.TypeAlert = "";
      self.MessageAlert = "";
      self.CloseScannerDialog();
      self.$router.push("/Main");
    },

    GetDataRateCode(membertype, vehicletype) {
      let self = this;
      // self.LoadingDialog = true;
      let temp = {
        TenantID: self.TenantID,
        MemberType: membertype,
        VehicleType: vehicletype,
        DepartmentID: parseInt(self.DepartmentID),
      };
      axios
        .post(`${self.url}Redemption/GetDataRateCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
            // self.LoadingDialog = false;
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // self.LoadingDialog = false;
        });
    },

    CancelRedeem() {
      let self = this;
      self.DeletePreviousPOS();
      self.$router.push({ name: "Main" });
    },

    BindingDataResponse() {
      let self = this;
      if (self.response != "" && self.response != undefined) {
        if (self.response.length > 0 && self.response[0].status != "Fail") {
          self.ResponseData = self.response[0];
          self.TerminalID = self.response[0].terminalInId;
          self.DatetimeIn = self.response[0].entryDateTime;
          self.MemberType = self.response[0].memberTypeId;
          self.CarType = self.response[0].vehicleTypeId;
          self.TicketNo = self.response[0].ticketNo;
          self.DateTime = new Date(
            self.response[0].entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TimeIn =
            self.response[0].entryDateTime.split(" ").length > 0
              ? self.response[0].entryDateTime.split(" ")[1]
              : "";
          self.Duration =
            self.response[0].parkHH +
            " hrs " +
            self.response[0].parkMM +
            " mins";
          self.CarLicense = self.response[0].plateNo;
          self.VehicleName = self.response[0].vehicleTypeName;
          self.RateCodeString = self.response[0].rateCode;
          self.RateDetail = self.response[0].rateDetailTH;
          self.RateDetailENG = self.response[0].rateDetailEN;
          self.Total = self.response[0].total;
          this.GetDataRateCode(
            self.response[0].memberTypeId,
            self.response[0].vehicleTypeId
          );
          // console.log(self.response[0]);
        } else {
          self.MessageAlert = self.response[0].message;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        }
      } else {
        self.BackToMain();
      }
    },

    ClearRateData() {
      let self = this;
      self.RateData = null;
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    RedeemData() {
      let self = this;
      self.RedeemButtonStatus = true;
      if (
        self.LogID == "" ||
        self.TerminalID == null ||
        self.DatetimeIn == "" ||
        self.TicketNo == "" ||
        self.CarLicense == "" ||
        self.MemberType == null ||
        self.CarType == null ||
        self.TenantID == null ||
        (self.SpendingValue == "" &&
          self.POSValue == "" &&
          self.CouponValue == "" &&
          self.RateData == null)
      ) {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน!");
        self.RedeemButtonStatus = false;
      } else {
        let temp = {
          LogCarparkID: self.LogID,
          TerminalID: self.TerminalID,
          DatetimeIn: self.DatetimeIn,
          RunningNumber: self.TicketNo,
          PlateNumber: self.CarLicense,
          MemberType: self.MemberType,
          CarType: self.CarType,
          TenantID: self.TenantID,
          SpendingValue: self.SpendingValue == "" ? null : self.SpendingValue,
          POSValue:
            self.POSValue == "" ||
            self.POSValue == 0 ||
            self.POSValue == undefined
              ? null
              : self.POSValue.toString(),
          CouponValue:
            self.CouponValue == "" ||
            self.CouponValue == 0 ||
            self.CouponValue == undefined
              ? null
              : self.CouponValue.toString(),
          RateCode: self.RateData,
          UserID: parseInt(localStorage.getItem("UserID")),
          Remark: self.Remark,
        };
        axios
          .post(`${self.url}Redemption/RedeemParking`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              if (self.StatusReader == true) {
                self.CloseReader();
              }
              self.RedeemButtonStatus = false;
              self.$router.push({
                name: "Redemption",
                params: {
                  ResponseRedeem: response.data.data,
                  ratecode:
                    self.RateData == null
                      ? response.data.data
                      : self.RateList.filter(
                          (x) => x.rateCode == self.RateData
                        )[0].rateDetail,
                },
              });
            }
          })
          .catch(function (error) {
            self.MessageAlert = error;
            self.TypeAlert = "error";
            self.AlertDialog = true;
            self.RedeemButtonStatus = false;
          });
      }
    },

    async GetPromotionTiger() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      await axios
        .post(`${self.url}Redemption/GetPromotionTigerForWeb`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.UsagePOSValue = response.data.data.freeHour;
            if (response.data.data.totalAmount > 0) {
              self.POSValue = response.data.data.totalAmount.toString();
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // alert(error);
        });
    },

    async GetPromotionCoupon() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      await axios
        .post(`${self.url}Redemption/GetPromotionCouponForWeb`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.UsageCouponValue = response.data.data.freeHour;
            if (response.data.data.totalCoupon > 0) {
              self.CouponValue = response.data.data.totalCoupon.toString();
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // alert(error);
        });
    },

    LoadDataSettingParkingInfo() {
      let self = this;
      axios
        .get(`${self.url}Setting/LoadDataSettingParkingInfo`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.SiteName = response.data.data.siteName;
              self.ParkingInfoPageActiveStatus =
                response.data.data.activeStatus == true ? "1" : "2";
              self.ThemeColor = response.data.data.themeColor;
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // alert(error);
        });
    },

    OpenCheckPermissionDialog() {
      let self = this;
      self.CheckPermissionDialog = true;
    },
  },

  async mounted() {
    let self = this;
    self.response = self.$route.params.response;
    // console.log(self.$route.params.response);
    // self.LogID = self.$route.params.LogID;
    if (self.response.length > 0) {
      self.LogID = self.$route.params.response[0].logId;
    }
    self.RedemptionType = parseInt(localStorage.getItem("RedemptionType"));
    self.TenantID = parseInt(localStorage.getItem("TenantID"));
    localStorage.setItem("response", self.$route.params.response);
    self.BindingDataResponse();
    await self.GetPromotionTiger();
    await self.GetPromotionCoupon();
    self.LoadDataSettingParkingInfo();
  },
};
</script>
<style scoped>
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

* >>> .v-data-table-header-mobile {
  display: none;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
* >>> .v-label {
  color: green;
  justify-content: center;
}
</style>
